import React from "react";
// import PropTypes from 'prop-types'
import { connect } from "react-redux";
import { useRouter } from "next/router";
import Link from "next/link";
import DefaultHeader from "../../molecules/layout/Header/DefaultHeader";
import LoginCard from "../../organisms/Auth/LoginCard";

function LoginHeader() {
    return (
        <DefaultHeader>
            <div className="col-xl-5 col-lg-6 col-md-8 px-5 py-sm mt-sm">
                <h1 className="text-white">
                    Log <span className="text-secondary">In</span>
                </h1>
                <p className="text-lead text-white">
                    Log in to access your previous plans and checkout our new
                    plans and offers as well.
                </p>
            </div>
        </DefaultHeader>
    );
}

function ResetPassword() {
    const router = useRouter();
    return (
        <div className="row mt-3">
            <div className="col-6">
                <Link
                    href={{
                        pathname: "/accounts/password/request-reset",
                        query: router.query,
                    }}
                >
                    <a
                        className="text-gray"
                        // target="_blank"
                        // rel="noopener"
                        // href="https://api.inuua.net/password-reset/"
                    >
                        <small>Forgot password?</small>
                    </a>
                </Link>
            </div>

            <div className="col-6 text-right">
                <Link
                    href={{
                        pathname: "/accounts/register/",
                        query: router.query,
                    }}
                >
                    <a className="text-gray">
                        <small>Create new account</small>
                    </a>
                </Link>
            </div>
        </div>
    );
}

export const Login = (props) => {
    return (
        <>
            <div className="content">
                <div id="content-inner">
                    <div className="main-content">
                        <LoginHeader />
                        {/*  Page content wrapper  */}
                        <div className="container mt--9 pb-7 text-gray header-form-raised">
                            {/*  used to ensure login card is in the middle   */}
                            <div className="row justify-content-center">
                                {/*  login & reset password div  */}
                                <div className="col-lg-5 col-md-7 mt--150">
                                    <LoginCard />
                                    <ResetPassword />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

Login.propTypes = {
    // props: PropTypes
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(Login);
